var domainlist = ["pink.cat", "astro.com.my"];
export default function psl(location) {
    var regex = new RegExp("(" + domainlist.join("|") + ")", "g");
    var match = location.match(regex);
    if (!match)
        return match;
    else
        return match[0];
}
